let productdescriptionReadMoreButton;
let readMoreText;
let readLessText;
let productDescriptionSection;
let buffer = 100;
let maxContentLength;
let showMoreButtonVisible = false;
let htmlStringText;
let maxLength;
let upgradedProductData;
let oldProductDescription;
const BLOCK_SELECTOR = '.price__block';
const RADIO_SELECTOR = 'input[type="radio"]';
const PRICE_CONTAINER = '.product .product__price';

function initEventHandlers() {
    upgradedProductData = $('.product').data('product-details');
    if(upgradedProductData && upgradedProductData.IsUpgradedPDP) {
        productDescriptionSection = $('.upgraded-product .product__details .product__details-description');
        $(productDescriptionSection).on('descriptionChange', handleDescriptionChange);
        productdescriptionReadMoreButton = $('#product__details-read-more-btn');
        readMoreText = $(productdescriptionReadMoreButton).data('read-more-label');
        readLessText = $(productdescriptionReadMoreButton).data('read-less-label');
        oldProductDescription = $(productDescriptionSection).html();
        $(productdescriptionReadMoreButton).on('click', enableDescriptionReadMoreLess);
        maxContentLength = $(productDescriptionSection).text().length;
        updateDescriptionOnReadMoreLess();

        const filterLength = $('.upgraded-product .product__selected--multi-facets .product__selector.filter ul.product__mobile-list li').length;
        if(filterLength <= 1) {
            $('.upgraded-product .product__selected--multi-facets .product__selector.filter button.product__mobile-toggle').removeClass('product__mobile-toggle-flex');
        } else {
            $('.upgraded-product .product__selected--multi-facets .product__selector.filter button.product__mobile-toggle').addClass('product__mobile-toggle-flex');
        }
    }

    $(PRICE_CONTAINER).on('keydown', `${BLOCK_SELECTOR}`, handlePriceSectionKeyDown);
}

function handleDescriptionChange() {
    if(upgradedProductData && upgradedProductData.IsUpgradedPDP) {
        showMoreButtonVisible = false;
        if(!$(productDescriptionSection).hasClass('product__details-description-collapsed')) {
            $(productDescriptionSection).addClass('product__details-description-collapsed');
        }
        $(productdescriptionReadMoreButton).addClass('d-none');
        maxContentLength = $(productDescriptionSection).text().length;
        updateDescriptionOnReadMoreLess();
        $(productdescriptionReadMoreButton).text(readMoreText);
    }
}

function updateDescriptionOnReadMoreLess() {
    if(upgradedProductData && upgradedProductData.IsUpgradedPDP) {
        if(showMoreButtonVisible) {
            htmlStringText = oldProductDescription;
        } else {
            htmlStringText = $(productDescriptionSection).html();
            oldProductDescription = htmlStringText;
        }
        maxLength = $(productdescriptionReadMoreButton).data('max-count');
        if(maxContentLength <= maxLength + buffer || maxLength === 0) {
            showMoreButtonVisible = false;
        } else {
            if($(productdescriptionReadMoreButton).hasClass('d-none')) {
                $(productdescriptionReadMoreButton).removeClass('d-none');
            }
            showMoreButtonVisible = true;
        }
        if(maxLength !== 0 && showMoreButtonVisible) {
            let truncatedContent = truncateHTML(htmlStringText, maxLength);
            if(truncatedContent.length < htmlStringText.length) {
                $(productDescriptionSection).html(truncatedContent);
            }
        }
    }
}

function enableDescriptionReadMoreLess() {
    updateDescriptionOnReadMoreLess();
    if(upgradedProductData && upgradedProductData.IsUpgradedPDP) {
        if(
            $(productDescriptionSection).hasClass('product__details-description-collapsed')) {
            $(productDescriptionSection)
                .removeClass('product__details-description-collapsed')
                .html(htmlStringText);
            $(this).text(readLessText);
        } else {
            $(productDescriptionSection)
                .addClass('product__details-description-collapsed')
                .html(truncateHTML(htmlStringText, maxLength));
            $(this).text(readMoreText);
        }
    }
}

export function truncateHTML(html, maxChars) {
    function getTagName(tag) {
        const tagNameMatch = tag.match(/^<\/?([^\s/>]+)/);
        return tagNameMatch ? tagNameMatch[1].toLowerCase() : null;
    }
    function findSentenceEnd(text, maxLen) {
        const sentenceEndRegex = /[.](?=\s|$)/g;
        let match;
        let lastIndex = -1;
        while ((match = sentenceEndRegex.exec(text)) !== null) {
            if(match.index <= maxLen) {
                lastIndex = match.index + 1; // Include the sentence ending character
            } else {
                break;
            }
        }
        return lastIndex === -1 ? maxLen : lastIndex;
    }
    if(upgradedProductData.IsUpgradedPDP) {
        if(html) {
            let charCount = 0;
            let output = '';
            let openTags = [];
            const tagRegex = /<\/?[^>]+>/g;
            const selfClosingTags =
                /^(area|base|br|col|embed|hr|img|input|link|meta|param|source|track|wbr)$/i;
            const commentRegex = /<!--[\s\S]*?-->/g;
            const entityRegex = /&[a-zA-Z0-9#]+;/g;
            // Remove comments and doctype from the HTML
            html = html.replace(commentRegex, '');
            // Split the input into parts that are either tags or text
            const parts = html.split(tagRegex);
            let match;
            let currentIndex = 0;
            while ((match = tagRegex.exec(html)) !== null) {
                const tag = match[0];
                const tagName = getTagName(tag);
                const part = parts.shift();
                // Handle special characters (HTML entities)
                const entityMatches = part.match(entityRegex) || [];
                const entityCount = entityMatches.length;
                // Add the text before the tag to the output
                if(part && charCount + part.length - entityCount <= maxChars) {
                    output += part;
                    charCount += part.length - entityCount;
                } else if(part) {
                    let remainingChars = maxChars - charCount;
                    let truncatedPart;
                    if(part.length <= remainingChars + buffer) {
                        truncatedPart = part;
                    } else {
                        let sentenceEndIndex = findSentenceEnd(part, part.length);
                        truncatedPart = part.slice(0, sentenceEndIndex);
                        if(!truncatedPart) {
                            truncatedPart = part;
                        }
                    }
                    // Ensure entities are not cut off
                    truncatedPart = truncatedPart.replace(/&[a-zA-Z0-9#]*$/, '');
                    output += truncatedPart;
                    charCount += truncatedPart.length;
                }
                // Stop if we reached the max character count
                if(charCount >= maxChars) {
                    break;
                }
                // Handle the current tag
                if(tagName) {
                    if(tag[1] === '/') {
                        // Closing tag
                        if(openTags.length && openTags[openTags.length - 1] === tagName) {
                            openTags.pop();
                        }
                        output += tag;
                    } else if(!selfClosingTags.test(tagName)) {
                        // Opening tag
                        openTags.push(tagName);
                        output += tag;
                    } else {
                        // Self-closing tag
                        output += tag;
                    }
                }
                currentIndex = match.index + tag.length;
            }
            // Add any remaining text if within the character limit
            if(charCount < maxChars) {
                output += html.slice(currentIndex, currentIndex + maxChars - charCount);
            }
            // Close any remaining open tags
            while (openTags.length) {
                output += `</${openTags.pop()}>`;
            }
            return output;
        } else {
            return html;
        }
    }
}

function handlePriceSectionKeyDown(e) {
    const $current = $(e.currentTarget);
    const $container = $current.closest(PRICE_CONTAINER);
    const $blocks = $container.find(BLOCK_SELECTOR);

    const index = $blocks.index($current);
    let $target;

    switch (e.key) {
        case 'ArrowDown':
        case 'ArrowRight':
            $target = $blocks.eq((index + 1) % $blocks.length);
            break;

        case 'ArrowUp':
        case 'ArrowLeft':
            $target = $blocks.eq((index - 1 + $blocks.length) % $blocks.length);
            break;

        case ' ':
        case 'Enter':
            $current.find(RADIO_SELECTOR).trigger('click');
            e.preventDefault();
            return;

        default:
            return;
    }

    $target.focus();
    $target.find(RADIO_SELECTOR).trigger('click');
    e.preventDefault();
}

$(function () {
    initEventHandlers();
});
